import { createApp } from 'vue';
import CameraAccessoriesSelection from '../components/CameraAccessoriesSelection.vue';

document.addEventListener('DOMContentLoaded', () => {
    const mountElements = document.querySelectorAll('.camera-accessories-selection-app');

    mountElements.forEach(element => {
        const accessories = element.dataset.accessories
            ? JSON.parse(element.dataset.accessories)
            : { cables: [], powerSupplies: [], lenses: [] };
        const translations = element.dataset.translations
            ? JSON.parse(element.dataset.translations)
            : {};

        const app = createApp(CameraAccessoriesSelection, {
            accessories,
            translations,
        });

        app.mount(element);
    });
});
